// extracted by mini-css-extract-plugin
module.exports = {"disableScroll":"withSpacing_disableScroll__1DBaH","hideInPercy":"withSpacing_hideInPercy__2lezd","spacing-2":"withSpacing_spacing-2__1HLj3"};